// Experiment:
// https://ab.daylight.stitchfix.com/expts/1792
export const frontDoorOfferExp = {
  expectedValues: ['no_promo', 'standard', 'percentage'],
  fallbackValue: 'standard',
  name: 'fy27-q1-fd-offer-experiment'
};